import { render, staticRenderFns } from "./CPTCodes.vue?vue&type=template&id=e05a93c6&scoped=true&"
import script from "./CPTCodes.vue?vue&type=script&lang=js&"
export * from "./CPTCodes.vue?vue&type=script&lang=js&"
import style0 from "./CPTCodes.vue?vue&type=style&index=0&id=e05a93c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05a93c6",
  null
  
)

export default component.exports